import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import { sagaMiddleware, runSagas } from '../sagas';
import { reducers } from '../reducers';
import { localStorage } from '../services/local-storage';
export var store;

function init() {
  var composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;
  var enhancer;

  if (process.env.NODE_ENV === 'development') {
    enhancer = applyMiddleware(sagaMiddleware, createLogger());
  } else {
    enhancer = applyMiddleware(sagaMiddleware);
  }

  store = createStore(reducers, {
    entities: {},
    components: {},
    user: localStorage.get('user', {}, false)
  }, composeEnhancers(enhancer));
  runSagas();
}

export function getStore() {
  if (!store) {
    init();
  }

  return store;
}